import { Feedback } from './styled';

export default Feedback;
